module.exports = "/img/ford.922aac02.png";